export const range = (n: number) => [...new Array(n)].map((_, i) => i);

export const ranges = (start, end, step): number[] => {
    const result: number[] = [];
    for (let i = start; i < end; i += step) {
        result.push(i);
    }
    return result;
};

export const union = (...arrays): number[] => {
    const set = new Set<number>();
    for (const array of arrays) {
        for (const item of array) {
            set.add(item);
        }
    }
    return Array.from(set);
};

export const removeDuplicates = <TValue = string>(array: TValue[]) =>
    array.reduce((accumulator: TValue[], currentDeviceType: TValue) => {
        const hit = accumulator.some((deviceType) => JSON.stringify(deviceType) === JSON.stringify(currentDeviceType));
        if (!hit) {
            return [...accumulator, currentDeviceType];
        }
        return accumulator;
    }, []);

export const uniqBy = <TValue = Record<string, any>>(a: TValue[], key: keyof TValue) => {
    const seen = new Set();
    return a.filter((item) => {
        const k = item[key];
        return seen.has(k) ? false : seen.add(k);
    });
};

export const groupBy = <TValue extends object>(
    list: TValue[],
    getKey: (arg: TValue) => string,
): Record<string, TValue[]> => {
    return list.reduce((acc, cur) => {
        const comp = getKey(cur);
        if (acc[comp]) {
            return { ...acc, [comp]: [...acc[comp], cur] };
        }
        return {
            ...acc,
            [comp]: [cur],
        };
    }, {});
};
